/**
 * This code was AUTOGENERATED using the codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getEnumDecoder,
  getEnumEncoder,
  type Codec,
  type Decoder,
  type Encoder,
} from '@solana/kit';

export enum IntegerOperator {
  Equal,
  NotEqual,
  GreaterThan,
  LessThan,
  GreaterThanOrEqual,
  LessThanOrEqual,
  Contains,
  DoesNotContain,
}

export type IntegerOperatorArgs = IntegerOperator;

export function getIntegerOperatorEncoder(): Encoder<IntegerOperatorArgs> {
  return getEnumEncoder(IntegerOperator);
}

export function getIntegerOperatorDecoder(): Decoder<IntegerOperator> {
  return getEnumDecoder(IntegerOperator);
}

export function getIntegerOperatorCodec(): Codec<
  IntegerOperatorArgs,
  IntegerOperator
> {
  return combineCodec(getIntegerOperatorEncoder(), getIntegerOperatorDecoder());
}
